<template>
  <div class="form-generator">
    <b-form @submit.prevent="submit" @reset="onReset">
      <h3>
        <strong>{{ title }}</strong>
      </h3>
      <b-form-group>
        <label class="form__label">Select user *</label>
        <multiselect
          v-model="form.user"
          tag-placeholder="select users"
          :options="locUsers"
          track-by="name"
          label="name"
          :showLabels="false"
          required
        ></multiselect>
      </b-form-group>
      <b-form-group>
        <label class="form__label">Select project *</label>
        <multiselect
          v-model="form.project"
          :allow-empty="true"
          tag-placeholder="select something"
          :options="locProjects"
          track-by="name"
          label="name"
          :showLabels="false"
          required
        ></multiselect>
      </b-form-group>
      <div class="row">
        <div class="col">
          <b-form-group>
            <label class="form__label">Booking type *</label>
            <multiselect
              :allow-empty="false"
              v-model="form.booking_type"
              :value="bookingTypes[0]"
              tag-placeholder="Select type"
              :options="bookingTypes"
              track-by="name"
              label="name"
              :showLabels="false"
              required
            ></multiselect>
          </b-form-group>
        </div>
      </div>
      <div class="row" v-if="!isTypePeriod">
        <div class="col">
          <b-form-group>
            <label class="form__label">Hours *</label>
            <b-form-input
              placeholder="10"
              type="number"
              v-model="form.booking_hours"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row" v-if="isTypePeriod">
        <div class="col">
          <b-form-group>
            <label class="form__label">From date *</label>
            <datepicker
              placeholder="Select Date"
              :value="_toIsoStringTime(form.date_from)"
              @input="
                form.date_from = _toLocalTime($event);
                getDate(form.date_from, 'from');
              "
              :disabledDates="{ to: new Date(new Date() - 86400000) }"
              :format="dateFormat"
              :bootstrap-styling="true"
              class="datapicker"
            />
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group>
            <label class="form__label">To date *</label>
            <datepicker
              placeholder="Select Date"
              :value="_toIsoStringTime(form.date_to)"
              @input="
                form.date_to = _toLocalTime($event);
                getDate(form.date_to);
              "
              :disabledDates="{ to: new Date(fromDateUTC - 8640000) }"
              :format="dateFormat"
              :bootstrap-styling="true"
              class="datapicker"
            />
          </b-form-group>
        </div>
      </div>
      <b-form-group v-if="isTypePeriod">
        <label class="form__label">Hours per day *</label>
        <multiselect
          placeholder="Select option"
          v-model="form.hoursPerDay"
          :options="hoursPerDayOptions"
          track-by="value"
          label="label"
          :showLabels="false"
        ></multiselect>
      </b-form-group>
      <b-form-group>
        <label class="form__label">Comment</label>
        <b-form-textarea
          id="textarea"
          v-model="form.comment"
          placeholder="Enter comment"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <div class="form-generator__controls" v-if="edit">
        <div class="form-generator-buttons">
          <b-button @click="remove" class="button btn-secondary mr-auto">
            Remove
          </b-button>
          <b-button
            type="submit"
            :disabled="isButtonDisabled"
            class="button"
            variant="primary"
          >
            Edit
          </b-button>
        </div>
      </div>
      <div class="form-generator__controls" v-else>
        <div class="form-generator-buttons">
          <b-button type="reset" class="button" variant="outline"
            >Reset</b-button
          >
          <b-button
            type="submit"
            :disabled="isButtonDisabled"
            class="button ml-2"
            variant="primary"
          >
            Create
          </b-button>
        </div>
      </div>
    </b-form>
    <div class="preloader" v-if="showPreloader && isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateFrom } from '../../functions/format_date'
import Datepicker from 'vuejs-datepicker'
import { mapGetters, mapMutations } from 'vuex'
import Moment from 'moment'

export default {
  name: 'BookingForm',
  data () {
    return {
      dateFormat: 'dd/MM/yyyy',
      locUsers: [],
      locProjects: [],
      bookingTypes: [
        {
          name: 'Period',
          value: 1
        },
        {
          name: 'Hourly',
          value: 2
        }
      ],
      form: {
        date_from: '',
        date_to: '',
        project: '',
        user: '',
        hoursPerDay: '',
        comment: '',
        booking_hours: 0,
        booking_type: {
          name: 'Period',
          value: 1
        }
      }
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String
    },
    dataProps: {
      type: Object,
      default: () => {}
    },
    projects: {
      type: Array
    },
    users: {
      type: Array
    },
    modal: {
      type: Boolean
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    showPreloader: {
      type: Boolean,
      default: () => false
    },
    isModalLoading: {
      type: Boolean,
      default: () => false
    }
  },
  components: { Datepicker },
  mounted () {
    this.locProjects = this.projects
    this.locUsers = this.users
    this.setData()
  },
  watch: {
    'form.date_from': function (val) {
      if (Moment(val, 'YYYY-MM-DD').isAfter(this.form.date_to, 'YYYY-MM-DD')) {
        this.form.date_to = this.form.date_from
      }
    },
    dataProps: function (val) {
      this.setData()
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName'
    }),
    ...mapMutations({
      GET_USER_NAME: 'GET_USER_NAME',
      GET_USER_ROLE: 'GET_USER_ROLE'
    }),
    isButtonDisabled () {
      // eslint-disable-next-line
      return (
        (!this.form.date_from && this.isTypePeriod) ||
        // eslint-disable-next-line
        (!this.form.date_to && this.isTypePeriod) ||
        // eslint-disable-next-line
        (!this.form.hoursPerDay && this.isTypePeriod) ||
        !this.form.project ||
        !this.form.user ||
        // eslint-disable-next-line
        this.isLoading ||
        // eslint-disable-next-line
        (this.form.booking_hours < 1 && !this.isTypePeriod)
      )
    },
    hoursPerDayOptions () {
      return [
        {
          label: '30m',
          value: 0.5
        },
        {
          label: '1h',
          value: 1
        },
        {
          label: '1h 30m',
          value: 1.5
        },
        {
          label: '2h',
          value: 2
        },
        {
          label: '2h 30m',
          value: 2.5
        },
        {
          label: '3h',
          value: 3
        },
        {
          label: '3h 30m',
          value: 3.5
        },
        {
          label: '4h',
          value: 4
        },
        {
          label: '4h 30m',
          value: 4.5
        },
        {
          label: '5h',
          value: 5
        },
        {
          label: '5h 30m',
          value: 5.5
        },
        {
          label: '6h',
          value: 6
        },
        {
          label: '6h 30m',
          value: 6.5
        },
        {
          label: '7h',
          value: 7
        },
        {
          label: '7h 30m',
          value: 7.5
        },
        {
          label: '8h',
          value: 8
        }
      ]
      // return constants.hours_per_day
    },
    fromDateUTC () {
      if (this.form.date_from) {
        return Moment.utc(this.form.date_from, 'YYYY-MM-DD')
      }
      return Date.now()
    },
    isTypePeriod () {
      return !this.form.booking_type
        ? true
        : this.form.booking_type.value === 1
    }
  },
  methods: {
    async remove () {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete?'
      )

      if (!confirm) return

      this.$emit('remove', this.dataProps)
    },
    setData () {
      this.form.hoursPerDay = this.dataProps.hours_per_day
        ? this.hoursPerDayOptions.find(
          (item) => item.value === this.dataProps.hours_per_day
        )
        : null
      this.form.project = this.projects.find(
        (item) => item.id === this.dataProps.project_id
      )
      this.form.user = this.users.find(
        (item) => item.id === this.dataProps.user_id
      )
      this.form.booking_hours = this.dataProps.booking_hours

      this.form.booking_type = this.bookingTypes.find(
        (item) => item.value === this.dataProps.booking_type_id
      )
      this.form.date_from = this.dataProps.start_date
        ? this._toLocalTime(this.dataProps.start_date)
        : this._toLocalTime(new Date())
      this.form.date_to = this.dataProps.end_date
        ? this._toLocalTime(this.dataProps.end_date)
        : this._toLocalTime(new Date())

      this.form.comment = this.dataProps.comment
    },
    onReset (evt) {
      if (evt) {
        evt.preventDefault()
      }

      /* Reset our form values */
      for (let key in this.form) {
        this.form[key] = ''
      }
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    close () {
      this.$emit('close')
      this.onReset()
    },
    getDate (date, target) {
      let result = getDateFrom(date, target)
      if (target === 'from') {
        this.form.date_from = result
      } else {
        this.form.date_to = result
      }
    },
    submit () {
      const payload = {
        start_date: this.form.date_from,
        end_date: this.form.date_to,
        project_id: null,
        user_id: this.form.user.id,
        booking_type_id: this.form.booking_type.value,
        booking_hours: this.form.booking_hours,
        hours_per_day: this.form.hoursPerDay ? this.form.hoursPerDay.value : 0,
        comment: this.form.comment
      }
      if (this.isButtonDisabled) {
        return
      }
      this.$emit('submit', this.prepareToSend(payload))
    },
    prepareToSend (form) {
      if (this.form.project) {
        form.project_id = this.form.project.id
      } else {
        delete form.project_id
      }
      if (this.form.booking_type.value === 1) {
        delete form.booking_hours
      } else {
        delete form.start_date
        delete form.end_date
        delete form.hours_per_day
      }
      return form
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-form {
  position: relative;
  padding: 20px 30px;
}

.preloader {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}
</style>
